import { Modals } from "../components/Modals";
import { Table } from "../components/table-pagination-sorting/components/Table";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { useAppDispatch } from "../store/store";
import { useState, useRef, useEffect, useCallback } from "react";
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import {
  initialRecipe,
  propsRecipe,
  tablePaginationRs,
} from "../utils/formsInitialsStates";
import {
  getReceta,
  getRecetas,
  savetReceta,
} from "../services/fabricaServices";
import { showMessage } from "../reducers/msgReducer";
import { RecetaForm } from "../components/forms-modals/RecetaForm";

export const RecetaFabrica = () => {
  const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();

  const [data, setData] = useState({ count: 0 } as {
    count: number;
    rows: Array<{ [key: string]: any }>;
  });

  const [datosRecipe, setDatosRecipe] = useState(
    {} as { on: string; data: propsRecipe | undefined }
  );

  const recipeFormRef = useRef<{
    handleClick: () => propsRecipe;
    resetForm: () => void;
  }>();
  const paginationFilters = useRef({} as PaginatingAndSortingProps)
  const handelPagination = useCallback(
    (pagination: PaginatingAndSortingProps) => {
      paginationFilters.current = pagination;
      function searchDataRecipe(tipe: string, id: number) {
        doneFetchActions(getReceta(id)).then((resp: propsRecipe) => {
          setDatosRecipe({ on: tipe, data: resp });
        });
      }
      doneFetchActions(getRecetas(pagination)).then(
        (data: tablePaginationRs) => {
          data.rows = data.rows?.sort((a, b) => (b.estado === true ? 1 : -1)).map((ob) => ({
            ...ob,
            recetaMaterial: ob.recetaMaterial
            .map((item: { material: { nombre: string, unidad_medida: string } }) => `${item.material.nombre} - ${item.material.unidad_medida}`)
            .join(", "),
            estado:  ob.estado ? (
              <span className="icon-unlocked" style={{ color: '#007bff', fontSize: '1rem' }}></span>
            ) : (
              <span className="icon-lock" style={{ color: '#dc3545', fontSize: '1rem' }}></span>
            ),
            actions: (
              <>
                <button
                  className="btn"
                  onClick={() => searchDataRecipe("edit", ob.id)}
                >
                  <span className="icon-pencil"></span>
                </button>
              </>
            ),
          }));
          setData(data);
        }
      );
    },
    [doneFetchActions]
  );

  const onSaveModal = () => {
    const recipeValues = recipeFormRef.current?.handleClick();
    if (recipeValues) {
      
      doneFetchActions(savetReceta(recipeValues)).then((resp) => {
        dispatch(
          showMessage({
            isShow: true,
            title: "Receta registrada con éxito",
            type: "success",
          })
        );
        handelPagination(paginationFilters.current);
        setDatosRecipe({ on: "", data: initialRecipe });
        recipeFormRef.current?.resetForm();
      });
    }
  };
  useEffect(() => {
    handelPagination({} as PaginatingAndSortingProps);
  }, [handelPagination]);

  const onCloseModal = () => {
    recipeFormRef.current?.resetForm();
    setDatosRecipe({ ...datosRecipe, on: '' });
    
  };
  
  const titles = [
    { title: "Recetas", sort: "receta" },
    { title: "Materiales", name: "recetaMaterial" },
    // { title: "Cantidad", sort: "cantidad" },
    { title: "Descripción", sort: "descripcion" },
    { title: "Estado", name: "estado" },
    { title: "Acciones", name: "actions" },
  ];
 
  return (
    <div>
      <div className="d-flex justify-content-center pt-4">
        <h4 className="align-self-end">Recetas de Fabrica</h4>
      </div>
      <div className="d-flex justify-content-end pb-4">
        <div className="align-self-end">
          <button
            onClick={() => {
              setDatosRecipe({ on: "add", data: undefined });
            }}
            type="button"
            className="btn btn-primary btn-rounded mb-4"
          >
            Crear Receta
          </button>
        </div>
      </div>
      <div></div>
      <Table
        dataTable={{ ...data, titles, limit: 100 }}
        onChange={handelPagination}
      />
      <Modals
        title="Crear Receta"
        onSave={onSaveModal}
        onClose={onCloseModal}
        show={!!datosRecipe.on}
      >
        <RecetaForm
          ref={recipeFormRef}
          data={datosRecipe.data}
          on={datosRecipe.on}
        />
      </Modals>
    </div>
  );
};
